export default {
  unavailable: {
    title: 'Eingeschränkter Zugang für Self-Service-Partner',
    description:
      'Dieser Bereich ist für Partner im Self-Service-Onboarding nicht verfügbar. Bitte wende dich bei Bedarf an deinen Account Manager.',
  },
};
